import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { IconButton, Tooltip } from '@mui/material';
import {
  AddButtonIcon,
  CustomFieldValueCnt,
  ValuesSubTitle,
  ValuesTitle,
  ValuesTitleCnt
} from './styles';
import CustomFieldItem from './custom-field-item';

const RenderCustomFieldValues = ({
  memberIndex,
  forceError
}) => {
  const { control, handleSubmit } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `customFields.${memberIndex}.customFieldValues`,
    keyName: 'fieldId'
  });

  const addNewCustomFieldValue = handleSubmit(() => append({}));

  return (
    <>
      <ValuesTitleCnt>
        <ValuesTitle>Field values</ValuesTitle>
        <ValuesSubTitle>Omit this to allow custom value</ValuesSubTitle>
      </ValuesTitleCnt>
      {fields.map((field, index) =>
        <CustomFieldValueCnt key={field.fieldId}>
          <CustomFieldItem
            index={index}
            member={`customFields[${memberIndex}].customFieldValues[${index}]`}
            remove={remove}
            placeholder="Custom field value"
            forceError={forceError}
          />
        </CustomFieldValueCnt>)}
      <div>
        <IconButton
          size="small"
          onClick={addNewCustomFieldValue}
          aria-label="Add custom field value"
        >
          <Tooltip title="Add custom field value">
            <AddButtonIcon />
          </Tooltip>
        </IconButton>
      </div>
    </>
  );
};

export default RenderCustomFieldValues;
